import { component } from 'picoapp';

export default component((node, ctx) => {
  const { page, title = '', custom = 'false' } = node.dataset;
  const delay = page === 'index' ? 500 : 0;
  const header = node.querySelector('.header');
  const bar = document.querySelector('.announcement-bar');

  if (
    page !== 'index' &&
    page !== 'collection' &&
    page !== 'blog' &&
    title !== 'About Finding Ferdinand' &&
    custom !== 'true'
  ) {
    node.style.height = `${header.offsetHeight}px`;
  }

  window.addEventListener('scroll', () => {
    // console.log('window.scrollY', window.scrollY, header.offsetHeight);

    if (custom === 'false') {
      if (window.scrollY > 400) {
        node.classList.add('is-fixed');
        // bar.style.marginBottom = `${header.offsetHeight}px`;
      } else {
        node.classList.remove('is-fixed');
        // bar.style.marginBottom = 0;
      }
    }
  });

  setTimeout(() => {
    header.classList.add('is-active');
  }, delay);
});
